import React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";

const GenericDrawer = ({
  open,
  anchor = "right",
  onClose,
  title = "Drawer Title",
  content = "This is some dummy content inside the drawer.",
  onAction1,
  action1Label = "Action 1",
  width = 300,
  ...rest
}) => {
  const ContentComponent = content;
  
  const getDrawerWidth = () => {
    if (anchor === "top" || anchor === "bottom") return "auto";
    if (typeof width === 'string' && width.includes('%')) {
      return width;
    }
    return typeof width === 'number' ? `${width}px` : width;
  };

  const drawerWidth = getDrawerWidth();

  return (
    <Drawer 
      anchor={anchor} 
      open={open} 
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          maxWidth: drawerWidth,
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
        role="presentation"
      >
        <Divider />
        {/* Drawer Content */}
        <Box sx={{ flex: 1, padding: 2, overflow: 'auto' }}>
          {ContentComponent ? <ContentComponent {...rest} /> : null}
        </Box>
        <Divider />
        {/* Action Buttons */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            padding: 2,
            justifyContent: "flex-end",
            backgroundColor: "#f5f5f5",
          }}
        >
          <Button variant="outlined" onClick={onAction1}>
            {action1Label}
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default GenericDrawer;